/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Deal_Provision_ImpliedInputs */

const cs_deal_provision_implied = /** @type {(inputs: Deal_Provision_ImpliedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`≈ ${i?.percent} % ze základu`)
};

const en_deal_provision_implied = /** @type {(inputs: Deal_Provision_ImpliedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`≈ ${i?.percent}% of basis`)
};

/**
* | output |
* | --- |
* | "≈ {percent}% of basis" |
*
* @param {Deal_Provision_ImpliedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_provision_implied = /** @type {((inputs: Deal_Provision_ImpliedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Provision_ImpliedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_provision_implied(inputs)
	return cs_deal_provision_implied(inputs)
});